import { useCallback } from 'react';
import { useAPIContext } from '../../context/api';
import { InstagramAPI } from '../../../../constructs/instagram/interface';
import { InstagramReel } from '../../../../types/instagram-reel';

export const useInstagramReels = () => {
  const { callEndpoint } = useAPIContext();

  const fetchInstagramReels = useCallback(
    async (widgetId?: string): Promise<InstagramReel[]> => {
      try {
        const path = `/${widgetId}`;
        const response = await callEndpoint<InstagramAPI, 'get-reels'>('instagram', path, 'GET');
        return response;
      } catch (error) {
        console.error('Error obteniendo reels de Instagram:', error);
        return [];
      }
    },
    [callEndpoint]
  );

  const updateInstagramReels = async (widgetId?: string) => {
    try {
      const path = `/${widgetId}`;
      const response = await callEndpoint<InstagramAPI, 'update-reels'>('instagram', path, 'POST');
      return response;
    } catch (error) {
      console.error('Error actualizando reels:', error);
      return null;
    }
  };

  return {
    fetchReels: fetchInstagramReels,
    updateReels: updateInstagramReels
  };
};
